<template>
  <div class="content page-container" :class="{ 'is-mobile': isMobile }">
    <div class="invite-box" v-if="!isAbnormal && !isDeal">
      <div class="title">邀请加入</div>
      <div class="invite-content">
        <div class="content-left">
          <p>您好！</p>
          <p>{{ organizationInfo.org_name }}邀请您加入。</p>
          <p>优秀的人才，成就伟大的事业。祝您一切顺利。</p>
        </div>
        <div class="content-right">
          <p class="tips">如同意加入，可酌情提前补充个人信息</p>
          <el-form
            :model="form"
            :inline-message="true"
            label-width="80px"
            ref="form"
          >
            <el-form-item
              prop="name"
              label="姓名"
              required
              :show-message="false"
            >
              <el-input
                v-model="form.name"
                placeholder="请输入用户名"
              ></el-input>
              <p class="tips">用于工作时的对齐，必填</p>
            </el-form-item>
            <el-form-item prop="nickname" label="对外昵称">
              <el-input v-model="form.nickname" placeholder="请输入"></el-input>
              <p class="tips">用于工作中对学员（客户）显示</p>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="footer">
        <el-button type="primary" size="small" @click="handle(2)"
          >拒绝邀请</el-button
        >
        <el-button type="primary" size="small" @click="handle(1)"
          >接受加入</el-button
        >
      </div>
    </div>
    <div class="result-box" v-else-if="!isAbnormal && isDeal">
      <img src="@/assets/img/settle-in/success-icon.png" alt="" />
      <p>感谢操作，处理完成</p>
      <div class="btn-box">
        <el-button type="text" size="small" @click="jump('index')"
          >去官网</el-button
        >
        <el-button type="text" size="small" @click="jump('admin')"
          >去管理后台</el-button
        >
      </div>
    </div>
    <div class="result-box" v-else-if="isAbnormal">
      <img src="@/assets/img/bug.png" alt="" />
      <p>{{ abnormalInfo }}</p>
      <div class="btn-box">
        <el-button type="text" size="small" @click="jump('index')"
          >去官网</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import {
  getOrganizationInfo,
  joinOrganization,
} from "@saas/server-api/src/organization";
export default {
  data() {
    return {
      form: {
        name: "",
        nickname: "",
      },
      isMobile: window.innerWidth <= 768,
      organizationInfo: {},
      isAbnormal: false,
      abnormalInfo: "抱歉，您不在本次被邀请人员中，无法访问页面。",
      isDeal: false,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo.profile;
    },
  },
  watch: {
    userInfo: {
      handler(val) {
        this.form.name = val.username || "";
        this.form.nickname = val.nickname || "";
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.getInviteInfo();
  },

  methods: {
    ...mapActions(["getProfile"]),
    getInviteInfo() {
      const id = this.$route.params.inviteId;
      getOrganizationInfo({
        invite_id: id,
      })
        .then((res) => {
          const { code } = res;
          if (code === 1) {
            this.organizationInfo = res.data;
            this.isAbnormal = false;
          } else if (code === 20011 || code === 20016) {
            this.isAbnormal = true;
            // 组织不存在或者邀请不存在
            this.$router.push("/404");
          } else if (code === 20013) {
            // 邀请失效
            this.isAbnormal = true;
            this.abnormalInfo = "邀请已失效，请联系相关人员重新邀请。";
          } else if (code === 20012) {
            // 已加入组织
            this.isAbnormal = true;
            this.abnormalInfo = "您已经加入了机构，无法同时加入更多机构。";
          } else if (code === 20014) {
            this.isAbnormal = true;
            this.abnormalInfo = "抱歉，您不在本次被邀请人员中，无法访问页面。";
          } else {
            this.isAbnormal = true;
            this.$message.error(res?.message || "请求失败");
          }
        })
        .catch((err) => {
          console.log("获取组织信息失败", err);
        });
    },
    join(status) {
      joinOrganization({
        invite_id: this.organizationInfo.invite_id,
        name: this.form.name,
        nickname: this.form.nickname,
        org_id: this.organizationInfo.org_id,
        status,
      })
        .then((res) => {
          const { code, message } = res;
          if (code === 1) {
            this.isDeal = true;
            if (status === 1) {
              this.getProfile();
              this.$message.success("加入成功");
            }
          } else if (code === 20011 || code === 20016) {
            this.isAbnormal = true;
            // 组织不存在或者邀请不存在
            this.$router.push("/404");
          } else if (code === 20013) {
            // 邀请失效
            this.isAbnormal = true;
            this.abnormalInfo = "邀请已失效，请联系相关人员重新邀请。";
          } else if (code === 20012) {
            // 已加入组织
            this.isAbnormal = true;
            this.abnormalInfo = "您已经加入了机构，无法同时加入更多机构。";
          } else if (code === 20014) {
            this.isAbnormal = true;
            this.abnormalInfo = "抱歉，您不在本次被邀请人员中，无法访问页面。";
          } else {
            this.$message.error(message);
          }
        })
        .catch((err) => {
          console.log("接受/拒绝邀请失败", err);
        });
    },
    handle(status) {
      if (status === 2) {
        this.$confirm("真的确认拒绝邀请码？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.join(2);
        });
      } else {
        if (!this.form.name) {
          this.$message.error("请输入姓名");
          return;
        }
        this.join(1);
      }
    },
    jump(type) {
      if (type === "admin") {
        window.open(`${process.env.VUE_APP_ADMIN_URL}`);
      } else {
        this.$router.push("/");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  display: flex;
  justify-content: center;
  align-items: center;
  .invite-box {
    background: #fff;
    width: 800px;
    border: 1px solid #ccc;
    display: flex;
    flex-direction: column;
    padding: 20px;
    justify-content: space-between;
    .title {
      line-height: 30px;
      font-size: 18px;
    }
    .invite-content {
      flex: 1;
      padding: 20px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .content-left {
        flex: 1;
        p {
          font-size: 20px;
          line-height: 36px;
          margin-bottom: 20px;
        }
      }
      .content-right {
        padding: 20px;
        margin-left: 20px;
        flex: 1;
        background: rgba($color: #000000, $alpha: 0.1);
        .tips {
          font-size: 14px;
          color: #555;
        }
        .el-form {
          margin-top: 20px;
        }
      }
    }
    .footer {
      display: flex;
      justify-content: flex-end;
    }
  }
  .result-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      width: 150px;
    }
    p {
      margin-top: 20px;
      font-size: 18px;
    }
    .btn-box {
      margin-top: 20px;
    }
  }
}
.is-mobile {
  .invite-box {
    width: 100%;
  }
}
</style>
